<div class="tenure-display" *ngIf="showYear || showMonth; else noTenureInput">
  <ng-container *ngIf="showYear"><span class="year-count">{{yearCount}}</span>yrs</ng-container>
  <ng-container *ngIf="showSpace">{{' '}}</ng-container>
  <ng-container *ngIf="showMonth"><span class="month-count">{{monthCount}}</span>mos</ng-container>
</div>
<ng-template #noTenureInput>
  <div class="tenure-display">-</div>
</ng-template>
